import { SubsidiaryFormValues } from 'features/new-actor/types/optim/subsidiaryFormValues';

/** Local refusals, checked before the API does. Texts are in ACTOR_FORM.LEGAL_ENTITY.SUBSIDIARIES.ERRORS. */
export enum SubsidiaryRefusal {
  IsParent = 'IS_PARENT',
  AlreadyInList = 'ALREADY_IN_LIST',
  MissingRegistrationNumber = 'MISSING_REGISTRATION_NUMBER',
  SameAsParentRegistrationNumber = 'SAME_AS_PARENT_REGISTRATION_NUMBER',
  DuplicateRegistrationNumber = 'DUPLICATE_REGISTRATION_NUMBER'
}

/** Same normalization as the back (Filiale.NormaliserSiret): whitespace is ignored. */
export const normalizeRegistrationNumber = (value?: string | null): string =>
  (value ?? '').replace(/\s/g, '');

/**
 * SIRET of a subsidiary row: must differ from the parent's and from every other row.
 * `currentId` is the row being edited, excluded from the duplicate check.
 */
export function getRegistrationNumberRefusal(
  registrationNumber: string | null | undefined,
  parentRegistrationNumber: string | null | undefined,
  subsidiaries: SubsidiaryFormValues[] | undefined,
  currentId?: string
): SubsidiaryRefusal | null {
  const siret = normalizeRegistrationNumber(registrationNumber);
  if (!siret) return null;

  if (siret === normalizeRegistrationNumber(parentRegistrationNumber)) {
    return SubsidiaryRefusal.SameAsParentRegistrationNumber;
  }

  const isDuplicate = (subsidiaries ?? []).some(
    row => row.id !== currentId && normalizeRegistrationNumber(row.registrationNumber) === siret
  );
  return isDuplicate ? SubsidiaryRefusal.DuplicateRegistrationNumber : null;
}

export interface AttachCandidate {
  id: string;
  registrationNumber?: string | null;
}

/** An existing legal entity picked in the search bar, before the attach dialog opens. */
export function getAttachRefusal(
  candidate: AttachCandidate,
  parent: { id?: string; registrationNumber?: string | null },
  subsidiaries: SubsidiaryFormValues[] | undefined
): SubsidiaryRefusal | null {
  if (parent.id && candidate.id === parent.id) {
    return SubsidiaryRefusal.IsParent;
  }
  if ((subsidiaries ?? []).some(row => row.legalPersonId === candidate.id)) {
    return SubsidiaryRefusal.AlreadyInList;
  }
  if (!normalizeRegistrationNumber(candidate.registrationNumber)) {
    return SubsidiaryRefusal.MissingRegistrationNumber;
  }
  return getRegistrationNumberRefusal(candidate.registrationNumber, parent.registrationNumber, subsidiaries);
}
